import { useEffect, useState } from "react";
import {
    AllAvailability,
    Cards,
    CustomDatePicker,
    Indicators,
    Inputs,
    SelectO,
} from "../../components";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { actionDoctor, actionPatient } from "../../redux/actions";
import { VscStarFull } from "react-icons/vsc";
import { useLocation } from "react-router-dom";
import { Commons } from "../../utilities";
import { useTranslation } from "react-i18next";
import { PiChat, PiHospital, PiPhone } from "react-icons/pi";

const DocDetails = ({ loginData }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();
    const doctorDetails = location.state?.doctorDetails;
    const [availableSlot, setAvailableSlot] = useState();
    const [dateRange, setDateRange] = useState([null, null]);
    const [options, setOptions] = useState([]);
    const [selectedClinic, setSelectedClinic] = useState("");


    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    const [credentials, setCredentials] = useState({
        appDate: formattedDate,
        location: "",
        physicianService: [],
        isMale: 0,
        languageId: [],
        appointmentType: 1,
        clinicGuid: loginData?.clinicGuid || doctorDetails?.clinicGuid,
        IsClinicSchedule: true,
        userTimeZone: loginData?.timeZoneId || doctorDetails?.doctorTimeZone,
        currency: loginData?.currencyCode || doctorDetails?.userCurrency,
        LanguageIds: loginData?.languageId || doctorDetails?.languageIDs?.[0],
    });
    const handleDateRangeChange = (range) => {
        setDateRange(range);
    };
    const handleChange = (type, value) => {
        switch (type) {
            case "clinic":
                setSelectedClinic(value);
                setCredentials((prev) => ({
                    ...prev,
                    clinicGuid:
                        value?.value !== loginData?.clinicGuid ? null : value?.value,
                }));
                break;
            default:
                break;
        }
    };
    useEffect(() => {
        dispatch(actionDoctor.getClinicDoctor(doctorDetails.doctorGuid));
    }, [dispatch, doctorDetails]);
    const getClinicDoctorData = useSelector(
        (state) => state.doctor.getClinicDoctorData?.data
    );
    useEffect(() => {
        if (getClinicDoctorData) {
            const newOption = getClinicDoctorData?.result?.map((item) => ({
                value: item.clinicGuid,
                label: item.clinicName,
            }));
            setOptions(newOption);
        }
    }, [getClinicDoctorData]);

    useEffect(() => {
        if (options?.length && loginData?.clinicGuid) {
            const matchedClinic = options.find(
                (opt) => opt.value === loginData.clinicGuid
            );
            if (matchedClinic) {
                setSelectedClinic(matchedClinic);
            }
        }
    }, [options, loginData]);
    useEffect(() => {
        dispatch(
            actionPatient.postSearchDoctorAppointment(
                credentials,
                doctorDetails.doctorGuid
            )
        );
    }, [dispatch, doctorDetails, credentials]);

    const postSearchDocAppoData = useSelector(
        (state) => state.patient.postSearchDocAppoData?.data?.result
    );


    useEffect(() => {
        if (postSearchDocAppoData) {
            setAvailableSlot(postSearchDocAppoData?.availableSlots);
        }
    }, [postSearchDocAppoData]);

    const shiftDateByWeeks = (baseDateStr, weekDiff) => {
        const baseDate = new Date(baseDateStr);
        baseDate.setDate(baseDate.getDate() + weekDiff * 7);

        const y = baseDate.getFullYear();
        const m = String(baseDate.getMonth() + 1).padStart(2, "0");
        const d = String(baseDate.getDate()).padStart(2, "0");

        return `${y}-${m}-${d}`;
    };

    const handlePreviousAvailability = () => {
        const currentDate = credentials.appDate;
        const prevDate = shiftDateByWeeks(currentDate, -1);

        const today = new Date();
        const prev = new Date(prevDate);

        // Prevent going before today
        if (prev < today.setHours(0, 0, 0, 0)) {
            return; // Do nothing
        }

        const updatedCredentials = {
            ...credentials,
            appDate: prevDate,
        };

        setCredentials(updatedCredentials);

        dispatch(
            actionPatient.postFetchNextAppointments(
                updatedCredentials,
                doctorDetails?.doctorGuid,
                true
            )
        );
    };
    const handleNextAvailability = () => {
        const currentDate = credentials.appDate;
        const nextDate = shiftDateByWeeks(currentDate, 1);

        const updatedCredentials = {
            ...credentials,
            appDate: nextDate,
        };

        setCredentials(updatedCredentials);

        dispatch(
            actionPatient.postFetchNextAppointments(
                updatedCredentials,
                doctorDetails?.doctorGuid,
                true
            )
        );
    };
    const getFetchNextAppointnentsData = useSelector(
        (state) => state.patient.getFetchNextAppointnentsData?.data
    );

    useEffect(() => {
        if (getFetchNextAppointnentsData) {
            setAvailableSlot(getFetchNextAppointnentsData?.result?.availableSlots);
        }
    }, [getFetchNextAppointnentsData]);

    const { displayedText, showFull, toggleShow, shouldTruncate } =
        Commons.useTruncateText(postSearchDocAppoData?.aboutClinic, 45);
    return (
        <Container className="exado-container" fluid>
            <Cards.HCardd
                className="Hcardd1"
                colClassNameImg="col-md-2"
                colClassNameImg1="col-md-10"
                imageSrc={postSearchDocAppoData?.doctorImage}
                cardBody={
                    <>
                        <div className="bdge-review-block">
                            <div>
                                {postSearchDocAppoData?.physicianServices?.map(
                                    (service, index) => (
                                        <span key={index} className="bdge exado_body_text_two">
                                            {service}
                                        </span>
                                    )
                                )}
                            </div>

                            <div className="review">
                                <span className="review-str exado-title-six">
                                    <VscStarFull className="str-num" /> 3.9
                                </span>
                                <span className="review-num exado-title-six">
                                    12 {t("review")}
                                </span>
                            </div>
                        </div>
                        <h2 className="exado-title-two dco-name">
                            {postSearchDocAppoData?.firstName +
                                " " +
                                postSearchDocAppoData?.lastName}
                        </h2>
                        <p
                            className={`exado-subTitle-two about showFull ${showFull ? "w-100" : "w-75"
                                }`}
                        >
                            {displayedText}
                            {shouldTruncate && (
                                <span onClick={toggleShow} className="custom-cursor-pointer">
                                    {showFull ? "Less" : "More"}
                                </span>
                            )}
                        </p>
                    </>
                }
            />
            {/* <Row className="exado-row1">
                <Col className="" md={12}>
                    <h3 className="exado-title-three">{t("contact_details")}</h3>
                </Col>
                <Col className="cd-col exado-subTitle-two" md={3}>
                    Schönlaterngasse 38/3 Vienna, 1040
                </Col>
                <Col className="cd-col exado-subTitle-two" md={3}>
                    {postSearchDocAppoData?.contact}
                </Col>
                <Col className="cd-col exado-subTitle-two" md={3}>
                    doc_cardio@tempsmtp.com
                </Col>
                <Col className="cd-col exado-subTitle-two" md={3}>
                    Goldenes Kreuz Private Hospital website link{" "}
                </Col>
            </Row> */}
            <Row className="exado-row1">
                <Col className="" md={12}>
                    <h3 className="exado-title-three">{t("price_list")}</h3>
                </Col>
                <span></span>
                <Col className="pl-col" md={12}>
                    <div className="price-list-blk ">
                        <div className="price-list exado-subTitle-two">
                            <PiChat className="me-3" />
                            {t("doctor_details.per_question_limit")}{" "}
                            <span className="pl-span">
                                {postSearchDocAppoData?.userCurrency}
                            </span>{" "}
                            10
                        </div>
                        <div className="price-list exado-subTitle-two">
                            <PiPhone className="me-3" />
                            {t("doctor_details.online_consultation")}{" "}
                            <span className="pl-span">
                                {postSearchDocAppoData?.userCurrency}
                            </span>{" "}
                            <span className="pl-span">
                                {postSearchDocAppoData?.onlineAppointmentFees}
                            </span>
                        </div>
                        <div className="price-list exado-subTitle-two">
                            <PiHospital className="me-3" />
                            {t("doctor_details.in_clinic_consultation")}{" "}
                            <span className="pl-span">
                                {postSearchDocAppoData?.userCurrency}
                            </span>{" "}
                            <span className="pl-span">
                                {postSearchDocAppoData?.inclinicAppointmentFees}
                            </span>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col className="" md={12}>
                    <h2 className="exado-title-two">{t("book_your_appointment")}</h2>
                </Col>
                <Col className="bya-col" md={12}>
                    <div className="d-flex align-items-center bya-block">
                        <div className="bya-select bya">
                            <SelectO.SelectO
                                options={options}
                                value={selectedClinic}
                                onChange={(selected) => handleChange("clinic", selected)}
                                className="select3"
                                placeholder={`${t("Select")}  ${t("Clinic")}`}
                                components={{ DropdownIndicator: Indicators.DropDownIndicator }}
                                isSearchable={false}
                            />
                        </div>
                        <div className="custom-date-range-picker bya">
                            <CustomDatePicker.CustomDateRangePicker
                                dateRange={dateRange}
                                onChange={handleDateRangeChange}
                                placeholderText={t("calender")}
                                className="customDateRangePicker"
                            />
                        </div>
                        <div className="bya">
                            <Inputs.CheckRadioInput
                                type="radio"
                                name="appointmentType"
                                label={t("In-Clinic") + " " + t("appointment")}
                                checked={credentials.appointmentType === 1}
                                onChange={() =>
                                    setCredentials({ ...credentials, appointmentType: 1 })
                                }
                                className="form-grp-radio"
                            />{" "}
                        </div>
                        <div className="bya">
                            <Inputs.CheckRadioInput
                                type="radio"
                                name="appointmentType"
                                label={t("OnLine") + " " + t("appointment")}
                                checked={credentials.appointmentType === 2}
                                onChange={() =>
                                    setCredentials({ ...credentials, appointmentType: 2 })
                                }
                                className="form-grp-radio"
                            />{" "}
                        </div>

                    </div>
                </Col>
                <Col className="bya-col" md={6}>
                    <AllAvailability.AvailabilitySlotList
                        availableSlot={availableSlot}
                        onPerClick={handlePreviousAvailability}
                        onNextClick={handleNextAvailability}
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col className="" md={12}>
                    <h2 className="exado-title-two">
                        {t("Education")} & {t("Certificates")}
                    </h2>
                </Col>
                <Col className="edu-col" md={12}>
                    <ul>
                        {postSearchDocAppoData?.educationModel?.map((education, index) => (
                            <li key={index} className="exado-subTitle-two edu-list">
                                <span className="edu-list-span">{education.degreeTitle}</span>{" "}
                                {t("From")}{" "}
                                <span className="edu-list-span">{education.collage}</span>,
                                {t("doctor_details.passed_in")}{" "}
                                <span className="edu-list-span">{education.passingYear}</span>.
                            </li>
                        ))}
                    </ul>
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col className="" md={12}>
                    <h2 className="exado-title-two">{t("Reviews")}</h2>
                </Col>
                <Col className="edu-col" md={12}>

                </Col>
            </Row>
            <Row className="exado-row1">
                <Col className="" md={12}>
                    <h2 className="exado-title-two">FAQs</h2>
                </Col>
                <Col className="edu-col" md={12}></Col>
            </Row>
        </Container>
    );
};

export default DocDetails;
